module.exports = __webpack_public_path__ + "img/spark_logo_white.1b837bbf.svg";